import { useCallback } from 'react'
import { Container } from '~/components/echarts/container'
import { handleExport } from '~/components/echarts/export'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'

export default function ECharts({
  title,
  chartInfoTitle,
  url,
  params,
  showMaximizeButton = true,
  showExportButton = false,
  hideLabels = false,
  fullScreenModalComponent,
}) {
  const { data, isLoading } = useRetryablePostJSON({ path: url, params })

  const computedTitle = title || data?.title

  const onExport = useCallback(
    async (format) => {
      return await handleExport(url, params, format)
    },
    [url, params],
  )

  return (
    <Container
      title={computedTitle}
      chartInfoTitle={chartInfoTitle}
      data={data}
      isLoading={isLoading}
      showMaximizeButton={showMaximizeButton}
      showExportButton={showExportButton}
      onExport={onExport}
      hideLabels={hideLabels}
      FullScreenModalComponent={fullScreenModalComponent}
    />
  )
}
